export default {
    local: 'https://fusebox.test/embed/player.js',
    staging: 'https://dev.app.fusebox.fm/embed/player.js',
    production: 'https://app.fusebox.fm/embed/player.js',
};
